export const hasAccountRight = (user, rightName) => Number(user?.Droits?.[rightName] || 0) > 0;

export const canWriteAccountFeature = (user, rightName) => (
  Boolean(user?.EcritureAutorisee) && hasAccountRight(user, rightName)
);

export const canCreateVehicle = (user) => canWriteAccountFeature(user, 'VehiculeCreate');
